import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";

// localStorage に保存されたデータを利用する
const ls = localStorage.getItem("vuex");
const firstBoot = ls !== null ? JSON.parse(ls).firstBoot : undefined;

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "firstBoot",
  preserveState: firstBoot !== undefined
})
class FirstBootModule extends VuexModule {
  isFirstBoot = true;

  @Mutation
  private SET_IS_FIRST_BOOT(isFirstBoot: boolean) {
    this.isFirstBoot = isFirstBoot;
  }

  @Action
  completeFirstBoot() {
    this.SET_IS_FIRST_BOOT(false);
  }
}

export const firstBootStore = getModule(FirstBootModule);
